import React from "react";

function Background() {
    return <div className="row">
        <div>
            <i className="fab fa-github"></i>
            <i className="fab fa-linkedin"></i>
            <i className="fa fa-code" aria-hidden="true"></i>
            <i className="fa fa-code-fork" aria-hidden="true"></i>
            <i className="fa fa-file-code-o" aria-hidden="true"></i>
            <i className="fa fa-terminal" aria-hidden="true"></i>
            <i className="fa fa-link" aria-hidden="true"></i>
            <i className="fa fa-laptop" aria-hidden="true"></i>
            <i className="fa fa-share-alt" aria-hidden="true"></i>
            <i className="fa fa-play" aria-hidden="true"></i>
            <i className="fa fa-bug" aria-hidden="true"></i>
            <i className="fa fa-music" aria-hidden="true"></i>
            <i className="fa fa-inr" aria-hidden="true"></i>
            <i className="fa fa-power-off" aria-hidden="true"></i>
            <i className="fa fa-wifi" aria-hidden="true"></i>
            <i className="fa fa-rocket" aria-hidden="true"></i>
            <i className="fa fa-wrench" aria-hidden="true"></i>
        </div>
        <div>
            <i className="fab fa-github"></i>
            <i className="fab fa-linkedin"></i>
            <i className="fa fa-code" aria-hidden="true"></i>
            <i className="fa fa-code-fork" aria-hidden="true"></i>
            <i className="fa fa-file-code-o" aria-hidden="true"></i>
            <i className="fa fa-terminal" aria-hidden="true"></i>
            <i className="fa fa-link" aria-hidden="true"></i>
            <i className="fa fa-laptop" aria-hidden="true"></i>
            <i className="fa fa-share-alt" aria-hidden="true"></i>
            <i className="fa fa-play" aria-hidden="true"></i>
            <i className="fa fa-bug" aria-hidden="true"></i>
            <i className="fa fa-music" aria-hidden="true"></i>
            <i className="fa fa-inr" aria-hidden="true"></i>
            <i className="fa fa-power-off" aria-hidden="true"></i>
            <i className="fa fa-wifi" aria-hidden="true"></i>
            <i className="fa fa-rocket" aria-hidden="true"></i>
            <i className="fa fa-wrench" aria-hidden="true"></i>
        </div>

    </div>;
}

export default Background;